module.exports = __webpack_public_path__ + "static/team_parag-17248f3d18510870eb44f5b86009e25b.jpeg";